import CustomZObject from './CustomZObject.js';
import Sample from "repos/Sample.js";

export default class SampleBank extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.samples = [];

        // sends the sample
        this.newInlet("send sample", ([msg]) => this.sendSample(msg));
        this.newOutlet("sample");
        this.lastSampleSent = undefined;
    }

    deleteSample(sample) {
        this.samples = this.samples.filter(
            x => x !== sample);
    }

    sendSample(sample) {
        if (typeof sample === "number") {
            sample = this.samples[sample % this.samples.length];
            if (!sample) {
                return;
            }
        }
        this.sendMessage("sample", sample);
        this.lastSampleSent = sample;
    }

    addSample(sample) {
        if (!this.samples.includes(sample)) {
            this.samples = [... this.samples, sample];
        }
    }

    getJson() {
        return {
            ... super.getJson(),
            samples: this.samples.map(x => x.getId())
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        
        this.fetchSamples(json.samples);
        // now we gotta get all the samples from the 
    }

    async fetchSamples(samples) {
        for (let id of samples) {
            let sample = new Sample(id);
            await sample.load(false);
            this.addSample(sample);
        }
    }
}
